module.exports = __webpack_public_path__ + "static/media/chia.b5a2e00b.jpg";